import CircularProgress from "@mui/material/CircularProgress";

const LoadingSpinner = ({ size = 40 }: { size?: number }) => {
    const padding = size / 2;
    return (
        <div style={{ display: "flex", justifyContent: "center", padding: `${padding}px` }}>
            <CircularProgress style={{ color: "var(--brand)" }} size={size} thickness={4} />
        </div>
    );
};

export default LoadingSpinner;
